import {createFeatureSelector, createSelector} from '@ngrx/store';
import {State} from './organization-account.cluster-instance-types.reducer';
import {InstanceType} from '../../../services/api/account/instance-types/instance-type.model';

export const loadClusterInstanceTypesFeatureKey = 'clusterInstanceTypes';
export const getClusterInstanceTypesSelector = createFeatureSelector<State>(loadClusterInstanceTypesFeatureKey);

export const getClusterInstanceTypes = createSelector(
  getClusterInstanceTypesSelector,
  (state: State): InstanceType[] => state.record
);

export const getClusterInstanceTypesLoaded = createSelector(
  getClusterInstanceTypesSelector,
  (state: State): boolean => state.loaded
);

export const getClusterInstanceTypesLoading = createSelector(
  getClusterInstanceTypesSelector,
  (state: State): boolean => state.loading
);

export const getClusterInstanceTypesError = createSelector(
  getClusterInstanceTypesSelector,
  (state: State): any => state.error
);
